import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./locales/i18n";
import { Loader } from "./icons";

ReactDOM.render(
  <React.StrictMode>
    <Suspense
      fallback={
        <div className="flex-100 justify-center fs-18 light-blue ptb-20 full-height align-items-center">
          <Loader height="72px" width="72px"></Loader>
        </div>
      }
    >
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
